import React from 'react';
import { Link } from '@lt/components';

import { useTranslation } from '@lt/localization';
import { Swiper, SwiperSlide } from 'swiper/react';

import SwipeReviewsCard from 'src/components/Reviews/ReviewCard/components/SwipeReviewCard/SwipeReviewCard';
import LinkButton from '../../LinkButton';

import styles from './reviewsMobile.module.css';
import type { ReviewsMobileProps } from './ReviewsMobile';

export const ReviewSwiper = ({
  items,
  isShowMoreVisible,
  isWhitelabel,
  hotelReviewsLink,
}: Pick<
  ReviewsMobileProps,
  'items' | 'isShowMoreVisible' | 'isWhitelabel' | 'hotelReviewsLink'
>): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.swiperReviewsCard}>
      <Swiper
        className={items.length > 1 ? styles.swiper : ''}
        slidesPerView="auto"
        spaceBetween={8}
      >
        {items.map((item) => {
          const ReviewCard = (
            <SwipeReviewsCard
              key={item.id}
              content={item.content}
              name={item.name}
              createdAt={item.createdAt}
              averageRating={item.averageRating}
              avatarUrl={item.avatarUrl}
              title={item.title}
              images={item.images}
              className={styles.reviewsCard}
            />
          );
          return (
            <SwiperSlide key={`slide-${item.id}`}>
              {isWhitelabel ? (
                <div>{ReviewCard}</div>
              ) : (
                <Link
                  href={hotelReviewsLink}
                  target="_blank"
                  style={{ color: '#17181A' }}
                >
                  {ReviewCard}
                </Link>
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
      {!isWhitelabel && isShowMoreVisible && (
        <div className={styles.showMoreContainer}>
          <LinkButton
            className={styles.showMoreLinkButton}
            href={hotelReviewsLink}
            size="flex"
          >
            {t('hotel.reviews.moreReviews')}
          </LinkButton>
        </div>
      )}
    </div>
  );
};
